import { render, staticRenderFns } from "./msgAlert.vue?vue&type=template&id=4cc9c392&scoped=true"
import script from "./msgAlert.vue?vue&type=script&lang=js"
export * from "./msgAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc9c392",
  null
  
)

export default component.exports